const BASE_API = process.env.VUE_APP_BASE_API

export default {
  api: {
    base: BASE_API,
    auth: {
      base: '/auth',
      login: '/auth/login',
      logout: '/auth/logout',
      register: '/auth/register',
      reset: '/auth/reset',
      account: '/auth/account',
    },
    admin: {
      base: '/admin',
      users: '/admin/users',
      statistics: '/admin/statistics',
      contractors: '/admin/contractors',
    },
    storage: {
      base: '/storage',
      upload: '/storage/upload',
    },
    crm: {
      base: '/crm',
      customers: '/crm/customers',
      customers_search: '/crm/customers/search',
    },
    pm: {
      base: '/pm',
      tasks: '/pm/tasks',
      teams: '/pm/teams',
      projects: '/pm/projects',
      contracts: '/pm/contracts',
    },
    marketing: {
      base: '/marketing',
      campaigns: '/marketing/campaigns',
      recipients: '/marketing/recipients',
      recipientsByFilter: '/marketing/recipients/filter',
    },
    system: {
      base: '/system',
      staffs: '/system/staffs',
      settings: '/system/settings',
    },
  },
}
